import React from 'react';
import { useAtomValue } from 'jotai';
import classNames from 'classnames/bind';
import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';

import useCustomRecommend from '@/hooks/custom/useCustomRecommend';
import {
  getFilteredRecommendsByDestinations,
  getFilterRecommendsByOrder,
  getTargetRecommends,
} from '@/utils/custom-travel';
import styles from './SelectDurationForm.module.scss';

const cx = classNames.bind(styles);

const RecommendDuration = () => {
  const { destinations } = useAtomValue(customTravelFormStateAtom);
  const customRecommends = useCustomRecommend();
  const recommendsFilterByDestination = getFilteredRecommendsByDestinations(customRecommends, destinations);
  const recommendsFilterByOrder = getFilterRecommendsByOrder(recommendsFilterByDestination);
  const recommendsFilterByPeriod = getTargetRecommends(recommendsFilterByOrder);
  if (!recommendsFilterByPeriod.length) return null;

  return (
    <>
      <div
        className={cx('announce')}
        data-event-nlog="imp"
        data-event-area-code="customtravel.recommendlocation"
        data-event-value={recommendsFilterByPeriod
          .map(({ name, month, dayPeriod, nightPeriod }, i) => `${name}-${month}-${dayPeriod}-${nightPeriod}-${i}`)
          .join(',')}
      >
        {recommendsFilterByPeriod.map(({ name, month, dayPeriod, nightPeriod }, idx) => (
          <div key={idx}>
            {name} 여행은
            <ul>
              {month && <li key="month">{month}월에 인기 있어요</li>}
              {nightPeriod && dayPeriod && (
                <li key="day">
                  {nightPeriod}박 {dayPeriod}일 일정으로 많이 가요.
                </li>
              )}
            </ul>
          </div>
        ))}
      </div>
      <div className={cx('notice')}>
        지난 1 년간, 네이버 패키지여행 상품 중 ‘풀패키지' 유형 예약 데이터를 기반으로 제공하는 정보입니다.
      </div>
    </>
  );
};

export default RecommendDuration;
